import { atom } from "jotai"
import { VisualEncodingProps } from "./types"

export const strokeDasharrayState = atom<VisualEncodingProps>({})
